import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  id: "patient-lookup",
  class: "lookupContainer mx-auto my-6"
}
const _hoisted_2 = {
  class: "sr-only",
  role: "status"
}
const _hoisted_3 = {
  key: 0,
  class: "statusBlock"
}
const _hoisted_4 = { class: "statusText" }
const _hoisted_5 = { class: "lookupSubtitle mb-3" }
const _hoisted_6 = { class: "selectedPatientCard elevation-1" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "flex-1 min-w-0" }
const _hoisted_9 = { class: "patientName" }
const _hoisted_10 = { class: "dobLine" }
const _hoisted_11 = { class: "dobValue" }
const _hoisted_12 = { class: "patientInfo metaLine" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "factLine"
}
const _hoisted_15 = { class: "flex items-center justify-between mt-3" }
const _hoisted_16 = { class: "patientInfo" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "lookupSubtitle mb-3" }
const _hoisted_19 = { class: "patientsList elevation-1" }
const _hoisted_20 = { class: "flex-1 min-w-0" }
const _hoisted_21 = { class: "patientName flex items-center flex-wrap" }
const _hoisted_22 = {
  key: 0,
  class: "statusTag text-xs font-bold ml-2"
}
const _hoisted_23 = { class: "dobLine" }
const _hoisted_24 = { class: "dobValue" }
const _hoisted_25 = { class: "patientInfo metaLine" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "factLine"
}
const _hoisted_28 = {
  key: 2,
  class: "patientInfo"
}
const _hoisted_29 = {
  key: 3,
  class: "noResultsMessage"
}
const _hoisted_30 = { class: "statusText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.liveStatus), 1),
    (_ctx.state === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            color: "primary",
            indeterminate: "",
            size: "40"
          }),
          _createElementVNode("p", _hoisted_4, "Looking up " + _toDisplayString(_ctx.displayPhone) + "…", 1)
        ]))
      : (_ctx.state === 'redirecting' && _ctx.only)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "lookupTitle my-2" }, "Incoming call", -1)),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.displayPhone), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_v_avatar, {
                  size: "52",
                  class: "mr-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_img, {
                      src: _ctx.only.avatar_url,
                      alt: _ctx.only.name
                    }, {
                      placeholder: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "52" }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-account-circle", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["src", "alt"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.only.name), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "dobLabel" }, "DOB", -1)),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dobLabel(_ctx.only)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_ctx.only.chart_id)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Chart ID: " + _toDisplayString(_ctx.only.chart_id), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, "Last visit: " + _toDisplayString(_ctx.lastVisitLabel(_ctx.only)), 1)
                  ]),
                  (_ctx.insuranceLine(_ctx.only))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["factLine", { selfPay: _ctx.isSelfPay(_ctx.only) }])
                      }, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.insuranceIcon(_ctx.only)), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.insuranceLine(_ctx.only)), 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.only.offices.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_v_icon, {
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-map-marker", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.only.offices.join(' · ')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.redirectRunning)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    class: "mt-4",
                    color: "primary",
                    height: "4",
                    "model-value": _ctx.redirectProgress,
                    rounded: ""
                  }, null, 8, ["model-value"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.countdownLabel), 1),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.redirectRunning)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        class: "mr-2",
                        density: "comfortable",
                        variant: "text",
                        onClick: _ctx.cancelRedirect
                      }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode(" Cancel ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    density: "comfortable",
                    variant: "flat",
                    onClick: _ctx.openChartNow
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Open now ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ], 64))
        : (_ctx.state === 'choosing')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "lookupTitle my-2" }, "Who is calling?", -1)),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.matchesLabel), 1),
              (_ctx.truncated)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    class: "mb-3",
                    density: "compact",
                    type: "warning",
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" This number is on more charts than can be listed — showing the " + _toDisplayString(_ctx.patients.length) + " most recently seen. ", 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patients, (patient) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: patient.uuid
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.chartUrlFor(patient) ? 'a' : 'div'), {
                      class: "patientItem",
                      href: _ctx.chartUrlFor(patient) || undefined
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          size: "52",
                          class: "mr-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_img, {
                              src: patient.avatar_url,
                              alt: patient.name
                            }, {
                              placeholder: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "52" }, {
                                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createTextVNode("mdi-account-circle", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["src", "alt"])
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("span", null, _toDisplayString(patient.name), 1),
                            (patient.status && patient.status !== 'active')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(patient.status), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "dobLabel" }, "DOB", -1)),
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.dobLabel(patient)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            (patient.chart_id)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Chart ID: " + _toDisplayString(patient.chart_id), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, "Last visit: " + _toDisplayString(_ctx.lastVisitLabel(patient)), 1)
                          ]),
                          (_ctx.insuranceLine(patient))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["factLine", { selfPay: _ctx.isSelfPay(patient) }])
                              }, [
                                _createVNode(_component_v_icon, {
                                  size: "16",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.insuranceIcon(patient)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("span", null, _toDisplayString(_ctx.insuranceLine(patient)), 1)
                              ], 2))
                            : _createCommentVNode("", true),
                          (patient.offices.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createVNode(_component_v_icon, {
                                  size: "16",
                                  class: "mr-1"
                                }, {
                                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                    _createTextVNode("mdi-map-marker", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createElementVNode("span", null, _toDisplayString(patient.offices.join(' · ')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.chartUrlFor(patient))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, " No DrChrono chart linked to this record "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  ]))
                }), 128))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_v_icon, {
                color: "#666",
                size: "32"
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-account-search", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.emptyTitle), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.emptyHint), 1),
              _createVNode(_component_v_btn, {
                class: "mt-4",
                color: "primary",
                variant: "flat",
                to: { path: '/scheduler' }
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Search patients manually ", -1)
                ]))]),
                _: 1
              })
            ]))
  ]))
}